import React from "react";
import Form from "react-bootstrap/Form";
import { FormLabel } from "../FormLabel";
import FormText from "../FormText";
import { autoCompleteFor } from "../utils";
import { FormGroupType } from "./types";

const FormGroup = ({
  value,
  id,
  displayValue,
  hint,
  required,
  type,
  placeholder,
  onChangeEvent,
  feedbackInvalid,
  invalid,
  wide,
}: FormGroupType) => {
  return (
    <Form.Group
      controlId={id}
      className={wide ? "jm-field jm-field-wide" : "jm-field"}
      style={{ gridColumn: wide ? "1 / -1" : undefined }}
    >
      <FormLabel
        displayValue={displayValue}
        hint={hint}
        required={required}
        invalid={invalid}
        htmlFor={id}
      />
      <Form.Control
        id={id}
        value={value}
        type={type}
        placeholder={placeholder}
        required={required}
        autoComplete={autoCompleteFor(id, type)}
        onChange={(evnt) => onChangeEvent(evnt)}
        isInvalid={feedbackInvalid !== "" && invalid}
      />
      {hint ? <FormText className="text-muted">{hint}</FormText> : null}
      <Form.Control.Feedback type="invalid">
        {feedbackInvalid}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default FormGroup;
